var _title, _g, _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrashThin = function SvgTrashThin(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M310.784 19.456c-7.168 7.68-8.704 20.48-8.704 66.048v56.832l-55.808 2.048c-47.104 1.024-58.368 3.072-70.656 12.288-27.136 19.968-32.256 37.888-32.256 118.272v73.216h66.56v307.712c0 343.040-1.024 331.264 35.328 353.792l18.432 11.776h248.32c271.872 0 271.872 0 293.376-30.208l11.264-15.872 5.12-624.64 64-3.072v-72.704c0-80.384-5.12-98.304-32.256-118.272-11.776-8.704-23.552-11.264-67.584-12.288l-52.736-2.048-2.048-55.296c-2.56-83.968 18.432-76.8-216.576-76.8-182.784 0-196.096 0.512-203.776 9.216zM660.48 110.080v33.28h-291.84v-66.56h291.84v33.28zM818.176 246.784l1.536 29.696h-609.792v-27.136c0-15.36 1.536-29.184 3.584-30.72 1.536-2.048 138.24-3.072 303.104-2.56l300.032 1.536 1.536 29.184zM752.64 647.168v299.52l11.776 2.048c6.144 1.024-100.352 2.048-237.056 1.536l-248.32-0.512-1.536-301.056-1.024-300.544h476.16v299.008z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M348.16 650.24v235.52h66.56v-471.040h-66.56v235.52z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M481.28 650.24v235.52h66.56v-471.040h-66.56v235.52z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M614.4 650.24v235.52h71.68v-471.040h-71.68v235.52z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrashThin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash-thin.f68a9856.svg";
export { ForwardRef as ReactComponent };